module.exports = "<p>\n  {{ 'info.itemNotFound' | translate }}\n</p>\n"